import type { ColumnDef } from "@tanstack/react-table";
import { msg } from "@lingui/core/macro";
import { Checkbox } from "@/components/ui/checkbox";
import { i18n } from "@/lib/i18n";

export function makeSelectColumn<TData>(): ColumnDef<TData, unknown> {
  return {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected()
            ? true
            : table.getIsSomePageRowsSelected()
              ? "indeterminate"
              : false
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label={i18n._(msg`Select all`)}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        onClick={(e) => e.stopPropagation()}
        aria-label={i18n._(msg`Select row`)}
      />
    ),
    enableSorting: false,
    enableHiding: false,
    size: 40,
  };
}
